import rs from 'jsrsasign';

import M from '../store/mutation-types';

export function processInitialData({$store}) {
	const pubKey = rs.KEYUTIL.getKey(process.env.VUE_APP_JWT_PUBLIC_KEY);
	const qs = window.location.search.substring(1);
	const params = new URLSearchParams(qs);
	const token = params.get('body');

	// Check if the token is present
	if (!token) {
		$store.commit(M.SET_ERROR, 'Invalid Link. Missing Token.');
		return;
	}

	// Check if the token is well-formed
	const tokenData = new rs.KJUR.jws.JWS();
	try {
		tokenData.parseJWS(token);
	} catch(ex) {
		$store.commit(M.SET_ERROR, 'Invalid Link. Link query string is malformed.');
		return;
	}

	// Check if the token is signed and unexpired
	try {
		if (!rs.KJUR.jws.JWS.verifyJWT(token, pubKey, {alg: ['ES256']})) {
			$store.commit(M.SET_ERROR, 'Invalid Link. Link signature is invalid or expired.');
			return;
		}
	} catch(ex) {
		$store.commit(M.SET_ERROR, 'Invalid Link. Signature verification failed.');
		// eslint-disable-next-line
		console.log('Signature verification error:', ex);
		return;
	}

	$store.commit(M.SET_INITIAL_DATA, JSON.parse(tokenData.parsedJWS.payloadS));
}

export function processOperatorToken({commit, dispatch, state}, token) {
	const tokenData = new rs.KJUR.jws.JWS();
	try {
		tokenData.parseJWS(token);
	} catch(ex) {
		commit(M.SET_ERROR, 'Server returned invalid token.');
		return;
	}

	// NOTE: This function DOES NOT validate the JWT since it is not safe to save the
	// shared SECRET in a public file. However, since this token is used to connect to
	// a server (via WS), it is easily determined if it is invalid at that point.

	commit(M.OPERATOR_SET_TOKEN, token);
	commit(M.OPERATOR_SET_DATA, JSON.parse(tokenData.parsedJWS.payloadS));
}
